export default __webpack_public_path__ + "static/media/star.26d64e09.png";